import jwt from 'jsonwebtoken';
import type { IUserToken } from '../types';
import { print } from 'graphql';
import { REFRESH_LEGACY_TOKEN } from './mutation/refreshToken';
import type { StoreDispatch } from './types';

const isValidToken = (decoded: unknown): decoded is IUserToken => {
  if (decoded === null || decoded === undefined || typeof decoded !== 'object') {
    return false;
  }
  const obj = decoded as Record<string, unknown>;
  return 'userId' in obj && 'email' in obj && 'acl' in obj;
};

export const refreshTokens = async (
  apiUrl: string, 
  refreshToken: string, 
  dispatch: StoreDispatch,
  apiKey?: string
): Promise<string> => {
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      ...(apiKey && { 'X-API-KEY': apiKey }),
    },
    body: JSON.stringify({
      query: print(REFRESH_LEGACY_TOKEN),
      variables: { token: refreshToken },
    }),
  });

  const json = await response.json();
  if (!response.ok || json.errors) throw new Error('Token refresh failed');

  const result = json.data?.refreshLegacyToken;
  if (!result?.accessToken || !result?.refreshToken) {
    throw new Error('Invalid refresh response');
  }

  const { accessToken, refreshToken: newToken } = result;
  const decoded = jwt.decode(accessToken);
  
  if (!isValidToken(decoded)) throw new Error('Invalid token');

  dispatch({
    isAuthenticated: true,
    user: decoded,
    token: accessToken,
    refreshToken: newToken,
  });

  return accessToken;
};

export const logout = (dispatch: StoreDispatch) => {
  dispatch({ isAuthenticated: false, user: null, token: null, refreshToken: null });
  window.location.href = '/login';
};
